import { useEffect, useState } from 'react';
import { loggedIn } from "../components/common";
// import { NewSiteWizard } from "../components/new-site-wizard";
import { subLoadbalancersBreadcrumbs } from "../components/common";

import { useNavigate } from 'react-router-dom';
import { NewLoadbalancerForm } from "../components/new-loadbalancer-form";

import {
  BreadcrumbGroup,
} from '@cloudscape-design/components';

import '../css/base.scss';

const Breadcrumbs = ({navigate, item}) => (
  <BreadcrumbGroup
    onFollow={event => {
      event.preventDefault();
      navigate(event.detail.href);
    }}
    items={subLoadbalancersBreadcrumbs(item)}
    expandAriaLabel="Show path"
    ariaLabel="Breadcrumbs" />
)

export default function NewLoadbalancer({ state }) {
  const navigate = useNavigate();
  if (!loggedIn()) {
    return null;
  }
  useEffect(() => {
    state.activeHref.setHref("/loadbalancers");
    state.breadCrumbs.setCrumbs(
      <Breadcrumbs navigate={navigate} item="Create Load Balancer" />
    )
    state.maxContentWidth.setWidth(Number.MAX_VALUE);
    state.contentType.setType("default");
  }, []);
  return (
      <NewLoadbalancerForm resource="Load Balancer" url="lbhosts" flashbar={state.flashBar}/>
  );
}
